import axios from 'axios'

import { toCamelCase } from '../helpers/utils'

export interface EldAvailableTime {
  dutyStatus: string
  retrievedAt: string
  clocks: EldAvailableTimeClock[]
}

export interface EldAvailableTimeClock {
  active: string
  kind: 'LIMIT' | 'SHIFT' | 'CYCLE'
  maxRestPeriod: string
  maxSleeperPeriod: string
  timeUntilRest: string
  rule: EldAvailableTimeClockRule
}

export interface EldAvailableTimeClockRule {
  policy: EldAvailableTimeClockRulePolicy
}

export enum EldAvailableTimeClockRulePolicy {
  DRIVING_LIMIT = 'DRIVING_LIMIT',
  DRIVING_BREAK = 'DRIVING_BREAK',
  ON_DUTY_LIMIT = 'ON_DUTY_LIMIT',
  CYCLE_LIMIT = 'CYCLE_EIGHT_DAY',
}

// API
export function getAvailableTime(user_id: string): Promise<EldAvailableTime | null> {
  const url = `/api/v3/eld/${user_id}/available-time/`
  return axios
    .get(url)
    .then((response) => toCamelCase(response.data) as EldAvailableTime)
    .catch(() => null)
}
